import {
  API_ENDPOINT,
  useClientApiV2AuthSignupCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthSignupCreateMutation(
  options?: Parameters<typeof useClientApiV2AuthSignupCreateMutation>[0]['options'],
) {
  return useClientApiV2AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V2_AUTH_SIGNUP,
    options,
  });
}

export default useClientAuthSignupCreateMutation;
